export default {
  title: 'Tabless',
  form: {
    tabless_id: {
      label: 'ID Tabless',
      placeholder: 'ID interno nel sistema Tabless',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    error: 'Salvataggio modifiche non riuscito',
    success: 'Modifiche salvate',
  },
  connected: {
    title: 'Tabless è connesso',
    description: 'Questa integrazione è configurata.',
  },
};
